import {Component} from "@angular/core";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {
  SiteCdfBuildingModel,
  siteCdfBuildingModelFactory,
  SiteCdfModel,
  siteCdfModelFactory,
} from "../../sites/site-detail.model";
import {CdfImportService} from "../../cdf/cdf-import.service";
import {toList} from "../../helpers/helpers";

@Component({
  templateUrl: "./site-cdf-dialog.template.pug",
  providers: [CdfImportService],
})
export class SiteCdfDialogComponent extends DialogComponent<SiteCdfModel, SiteCdfModel> implements SiteCdfModel {
  error: Error;
  canRemove: boolean = false;
  id: string;
  system: string;
  buildings: string[] = [];
  selectableBuildings: SiteCdfBuildingModel[];
  canSave: boolean = false;

  static showCreateDialog(dialogService: DialogService, cdf: SiteCdfModel): Promise<SiteCdfModel> {
    return dialogService.showDialog(SiteCdfDialogComponent, cdf as SiteCdfModel);
  }

  cancel(): void {
    this.close();
  }

  ready() {
    this.result = siteCdfModelFactory(this);
    if (this.id) this.canRemove = true;
  }

  clearBuildings() {
    this.selectableBuildings = [];
    this.canSave = false;
  }

  @handleErrors()
  async loadCdfDetails() {
    if (!this.id) {
      this.error = new Error("The value in Portico ID is required.");
      return;
    }
    const preview = await this.cdfImportService.getCdfPreview(this.id);
    this.selectableBuildings = toList(siteCdfBuildingModelFactory, preview.buildings);

    this.canSave = true;
  }

  save() {
    if (!this.canSave) return;
    this.buildings = this.selectableBuildings.filter(it => it.selected).map(it => it.name);
    this.result = siteCdfModelFactory(this);
    this.close();
  }

  remove() {
    this.result = siteCdfModelFactory({});
    this.close();
  }

  constructor(public dialogService: DialogService, private cdfImportService: CdfImportService) {
    super(dialogService);
  }
}
